<template>
  <div class="">
    <router-view class="" />
  </div>
</template>

<script>
export default {
  created () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss">

</style>
